import { stringify, parse } from 'flatted';
import * as CircularJSON from 'circular-json';

let FlattedApps = [];

if (process.env.LAYOUT_API_URL=='https://ws.test.cxp.mgcs.gov.on.ca/on-form-service') FlattedApps = [];

export const stringifyJson = (json: any, app: string) => {
    if (!json || Object.keys(json).length === 0) {
        return '';
    }
    if (FlattedApps.includes(app.toLowerCase())) {
        return stringify(json);
    }
    return CircularJSON.stringify(json);
}

export const parseJson = (json: string, app: string) => {
    if (!json) {
        return null;
    }
    if (app && FlattedApps.includes(app.toLowerCase())) {
        return parse(json);
    }
    return CircularJSON.parse(json);
} 
